/**
 * Map a market's lifecycle status to the watchlist `kind` it belongs to.
 *
 * The watchlist is one shared collection partitioned at read time by status
 * (mirrors the backend `STATUS_BY_KIND` in
 * `backend/backend-api-service/src/features/social/watchlist/service.ts`):
 *
 *   - `proposals` → backing
 *   - `markets`   → trading, resolved
 *   - `winners`   → graduated (winning outcome's token is live on the AMM)
 *
 * Status-agnostic surfaces (the market detail header, the markets-feed row
 * card) call this so a bookmark reads/writes against the view matching the
 * market's CURRENT status — keeping the bookmark indicator correct as a market
 * advances through its lifecycle. Unknown / pre-trading states fall back to
 * `markets`.
 */

export type WatchlistKind = 'markets' | 'proposals' | 'winners';

export function watchlistKindForStatus(status: string | null | undefined): WatchlistKind {
  switch (status) {
    case 'backing':
      return 'proposals';
    case 'graduated':
      return 'winners';
    default:
      return 'markets';
  }
}
